module.exports = __webpack_public_path__ + "static/media/amit_signature.aadfda57.svg";